<script>
import Quill from 'quill';
import Parchment from 'parchment';
import Dialog from '@/components/dialogs/FullscreenDialog';

/**
 * DialogButton Component
 *
 * Component Quill basic pluggability
 *
 * @property {Object}   [quill]    Quill editor object
 * @property {Boolean}  active
 *
 * @fires DialogButton#dismiss    return boolean
 */

export default {
  name: 'nx-dialog-button',
  props: {
    quill: {
      type: Object,
      validator: value => value instanceof Quill,
    },
    blot: HTMLElement,
    active: Boolean,
  },
  data() {
    return {
      name: 'blotName',
      data: {},
      error: [],
    };
  },
  computed: {
    buttonTitle() {
      return this.$t('message.block.insert');
    },
    formTitle() {
      return this.$t('message.block.form.title');
    },
  },
  components: {
    [Dialog.name]: Dialog,
  },
  methods: {
    insertBlot() {
      if (!this.blot) {
        const range = this.quill.getSelection(true);
        this.quill.insertEmbed(
          range.index,
          this.name,
          this.data,
          this.quill,
          Quill.sources.SILENT,
        );
      } else {
        this.updateBlot();
      }
      this.dismiss();
    },
    updateBlot() {
      if (!this.blot) {
        return;
      }
      const blot = Parchment.find(this.blot);
      const offset = blot.offset();
      blot.remove();
      this.quill.insertEmbed(
        offset,
        this.name,
        this.data,
        this.quill,
        Quill.sources.SILENT,
      );
    },
    removeBlot() {
      if (this.blot) {
        this.blot.remove();
      }
    },
    cleanupDialog() {},
    cleanupPreview() {
      if (this.$refs.preview && this.$refs.preview.childNodes) {
        while (this.$refs.preview.firstChild) {
          this.$refs.preview.removeChild(this.$refs.preview.firstChild);
        }
      }
    },
    dismiss() {
      this.$emit('dismiss', true);
      this.cleanupDialog();
    },
  },
};
</script>
